@if (viewVisible) {
  <ldw-document-toolbar [document]="document" [isReadOnly]="true" [allowStatusChange]="false"
    [showBookmark]='isBookmarkVisible'
  (closeSelected)="close()" (statusChanged)="statusHasChanged($event)"></ldw-document-toolbar>
  <ldw-document-view [document]="document" [readOnly]="true" [search]='search' [pageNumber]=pageNumber [pageZoom]=pageZoom ></ldw-document-view>
}
